function helpers() {
    only_numbers();
    //aspect_ratio('.item_image', 4, 3);
    //aspect_ratio_append('.show_image_edit', 9, 3.5);
}

function aspect_ratio(selector, x, y){
    let elems = document.querySelectorAll(selector);
    Array.prototype.slice.call(elems)
        .forEach(function (elem) {
            let w = elem.clientWidth;
            let ratio = w*y/x;
            elem.style.height = parseInt(ratio)+'px';
        });
}

function aspect_ratio_append(selector, x, y){
    let elems = document.querySelectorAll(selector);
    Array.prototype.slice.call(elems)
        .forEach(function (elem) {
            let w = elem.clientWidth;
            let ratio = w*y/x;
            //elem.style.height = parseInt(ratio)+'px';
            console.log(window.innerWidth);

            if (window.innerWidth <= 991) {
                //ratio = elem.offsetHeight; // alto real
                elem.style.cssText += '; height: auto;';
            } else {
                elem.style.cssText += '; height: '+parseInt(ratio)+'px;';
            }
            //elem.style.cssText += '; height: '+parseInt(ratio)+'px;';
        });
}

function only_numbers() {
    let inputs = document.querySelectorAll('.number_only');
    Array.prototype.slice.call(inputs)
        .forEach(function (input) {
            input.addEventListener('keypress', function (event) {
                //console.log(event.which);
                let keycode = event.which;
                if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57)))) {
                    event.preventDefault();
                }
            }, false)
        })
}

export { helpers }